<template>
    <div class="form-group" :class="{'has-error': formErrors.has($attrs.name) }">
        <label :for="$attrs.name" class="label">{{ label }}</label>
        <div class="field-group">
            <input
                v-bind="$attrs"
                v-on="{
                    ...$listeners,
                    input: event => $emit('input', event.target.value),
                    change: event => $emit('input', event.target.value),
                }"
                ref="input"
                :id="$attrs.name"
                class="text"
                :value="value"
                v-validate="validation"
            >
            <Transition name="fade">
                <p class="error" v-if="formErrors.has($attrs.name)">{{ formErrors.first($attrs.name) }}</p>
            </Transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseInput',
        inheritAttrs: false,
        props: {
            label: {
                required: true,
                type: String,
            },
            validation: {
                required: true,
                type: String,
            },
            value: {
                required: false,
                type: String,
                default: '',
            },
        },
        data() {
            return {
                isFocused: false,
            };
        },
    };
</script>


<template>
    <div class="form-group" :class="{'has-error': formErrors.has(name) }">
        <label :for="name" class="label">{{ label }}</label>
        <div class="field-group">
            <input
                class="text"
                :type="type"
                :value="value"
                :disabled="disabled"
                @input="updateValue"
                @change="updateValue"
                @blur="$emit('blur')"
                @focus="$emit('focus')"
            />
            <p class="error" v-if="formErrors.has(name)">{{ formErrors.first(name) }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String
            },
            label: {
                type: String
            },
            disabled: {
                type: Boolean,
                default: false
            },
            value: String,
            type: {
                type: String,
                default: 'text',
                validate: (val) => {
                    // we only cover these types in our input components.
                    return ['text', 'url', 'email', 'password', 'search'].indexOf(val) !== -1;
                }
            }
        },
        methods: {
            updateValue (e) {
                this.$emit('input', $event.target.value);
            }
        }
    };
</script>
